(function (upp) {
    'use strict';

    //TODO: Change from filters to directives, because of performance
    // http://codingsmackdown.tv/blog/2013/04/23/localizing-your-angularjs-apps-update/
    /**
     * Filter: i18n
     * Translates a string
     *
     * Usage: { string | i18n }
     */
    upp.filter('i18n', ['translator',
        function (translator) {
            return function (input, params) {
                return translator.i18n(input, params, undefined);
            }
        }
    ]);

    /**
     * Filter: range
     * Allows to generate a range of numbers for iterating, for example
     *
     * Usage: { expr | range:n } where n is the upper bound of the range (the lower bound is always 0)
     * Example: <any ng-repeat="n in [] | range:8"></any>
     */
    upp.filter('range', function () {
        return function (input, total) {
            total = Number(total);
            for (var i = 0; i < total; i++) {
                input.push(i);
            }

            return input;
        };
    });

    /**
     * Filter: dateAndTime
     * Converts a Date object to a formatted datetime string with the format DAY/MONTH/YEAR HOUR:MINUTE
     *
     * Usage: { expr | dateAndTime }
     */
    upp.filter('dateAndTime', function () {
        return function (input) {
            return input.toLocaleString();
        };
    });

    /**
     * Filter: sanitize
     * Sanitizes an input
     *
     * Usage: { expr | sanitize }
     */
    upp.filter('sanitize', ['utils',
        function (utils) {
            return function (input) {
                return utils.sanitize(input);
            };
        }
    ]);

    /**
     * Filter: trustUrl
     * Transforms the an url to an embeddable url
     *
     * Usage: { expr | trustUrl }
     */
    upp.filter('trustUrl', ['$sce', function ($sce) {
        return function (url) {
            return $sce.trustAsResourceUrl(url);
        };
    }]);

    /**
     * Filter: normalizedDate
     * Transforms an Object with day, month, year to Date Object
     *
     * Usage: { expr | normalizedDate }
     */
    upp.filter('normalizedDate', function() {
        return function (dateSelected) {
            var date = new Date();
            date.setDate(dateSelected.day);
            date.setMonth(dateSelected.month);
            date.setFullYear(dateSelected.year);
            return date;
        };
    });


    upp.filter('numberDecimalNoZero', ['$filter', function($filter) {
        return function(input, fractionSize) {
            if(input % 1 > 0){
                return $filter('number')(input, fractionSize);
            }else{
                return $filter('number')(input, 0);
            }
        };
    }]);

})(upp);




// WEBPACK FOOTER //
// ./src/app/common/filters/filters.js